<div style="position:relative">
  <ion-item
    button
    (click)="showOptions = !showOptions"
    (keypress)="true"
    class="dp-item"
    lines="none"
  >
    <ion-label class="label" [ngClass]="{ 'fill-option': fillOption }">{{
      label
    }}</ion-label>
    <ion-icon color="primary" name="chevron-down-outline" slot="end"></ion-icon>
  </ion-item>
  
  <div class="container-options" *ngIf="showOptions">
    <ng-container *ngFor="let option of options">
      <ion-item
        button
        lines="none"
        [ngClass]="{ 'option-selected': option === value }"
        class="option"
        *ngIf="option.visible"
        (click)="selectOption(option)"
        (keypress)="true"
      >
        {{ option.descripcion ?? option.name }}
      </ion-item>
    </ng-container>
  </div>
</div>
